export default __webpack_public_path__ + "static/media/sad.d90467f7.mp3";